<div
  class="request-item"
  [class]="{
    'request-item-active': selectedRequestItemId() === requestItem().id
  }"
  (click)="navigateToAnchor(requestItem().id)"
  [dataSelector]="dataSelectorStr + '-request-item-' + requestItem().id"
>
  @switch (requestItem().status) {
    @case (ClientRequestItemStatus.OPEN) {
      <awn-badge class="me-1" [highlight]="shouldHighlight" [dataSelector]="dataSelectorStr + '-request-item-status-icon-' + requestItem().id"></awn-badge>
    }

    @case (ClientRequestItemStatus.IN_REVIEW) {
      <awn-badge class="me-1" color="yellow" [highlight]="shouldHighlight" [dataSelector]="dataSelectorStr + '-request-item-status-icon-' + requestItem().id"></awn-badge>
    }

    @case (ClientRequestItemStatus.REJECTED) {
      <awn-badge class="me-1" color="red" [highlight]="shouldHighlight" [dataSelector]="dataSelectorStr + '-request-item-status-icon-' + requestItem().id"></awn-badge>
    }

    @case (ClientRequestItemStatus.DONE) {
      <awn-badge class="me-1" color="green" [dataSelector]="dataSelectorStr + '-request-item-status-icon-' + requestItem().id"></awn-badge>
    }
  }

  <span class="body-300" [dataSelector]="dataSelectorStr + '-request-item-name-' + requestItem().id">
    @if (itemReferenceId()) {
      <span class="reference-id">{{ itemReferenceId() }} </span>
    }
    {{ requestItem().name }}
  </span>
</div>